import React, { memo, useEffect, useState } from "react";

import "./busy-blocker.css";
import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";
import { BusyBlocker } from "./busy-blocker";

/**
 * This component will use the busy state from the context
 */
export const BusyBlockerContainer = memo(() => {
	const { busyEmitter } = useBusyBlockerContext();
	const [isBlocked, setIsBlocked] = useState(true);

	// Remove the root BusyBlocker
	useEffect(() => {
		const loadingEl = document.getElementById("loading");
		if (loadingEl) loadingEl.remove();
	}, []);

	// Set state if busyBlocker is enabled/disabled
	useEffect(() => busyEmitter.subscribe(setIsBlocked), [busyEmitter]);

	return <BusyBlocker isOpen={isBlocked} />;
});

BusyBlockerContainer.displayName = "BusyBlockerContainer";
